export default "__VITE_ASSET__CZ58$6sg__"